import { rgb } from 'polished'
export const palette = {
  common: {
    white: rgb(249, 249, 249),
    lightOrange: rgb(247, 143, 41),
    orange: rgb(242, 103, 35),
    yellow: rgb(253, 183, 42),
    purple: rgb(65, 50, 146),
    lightPurple: rgb(118, 71, 178),
    lightGrey: rgb(240, 238, 238),
    grey: rgb(205, 203, 219),
    darkGrey: rgb(108, 100, 113),
    lightBlue: rgb(27, 163, 230)
  },
  text: {
    secondary: rgb(65, 50, 146)
  }
}
